<template>
  <section class="admin-content">
    <Navbar />
    <div class="admin-main">

      <!-- ── Page Header ─────────────────────────────────────── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-user" style="font-size: 22px;"></i>
            </div>
            <div v-if="employeee && employeee.user">
              <h4 class="mb-0 font-weight-bold">
                {{ employeee.user.firstname }} {{ employeee.user.lastname }}
              </h4>
              <small style="opacity: .8;">{{ employeee.user.job_title || 'Employee' }}</small>
            </div>
            <div v-else>
              <h4 class="mb-0 font-weight-bold">Employee Profile</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Action Bar ─────────────────────────────────────── -->
        <div class="card action-card shadow mb-4"
          v-if="user && (user.id == 90 || user.user_role == 1)">
          <div class="card-body py-3 px-4 d-flex flex-wrap" style="gap: 8px;">
            <button class="btn btn-sm btn-outline-primary" @click="show = !show">
              <i class="fe fe-lock mr-1"></i> Change Password
            </button>
            <button class="btn btn-sm btn-outline-secondary" @click="showupdatedep = !showupdatedep">
              <i class="fe fe-shuffle mr-1"></i> Change Role
            </button>
            <button class="btn btn-sm btn-outline-info" @click="showedituser = !showedituser">
              <i class="fe fe-edit-2 mr-1"></i> Edit User
            </button>
            <button
              class="btn btn-sm btn-outline-success"
              @click="updateRole"
              v-if="employeee && employeee.user && employeee.user.user_role == 0"
            >
              <i class="fe fe-shield mr-1"></i> Make Admin
            </button>
            <button
              class="btn btn-sm btn-outline-warning"
              @click="updateRole"
              v-if="employeee && employeee.user && employeee.user.user_role == 1"
            >
              <i class="fe fe-shield mr-1"></i> Make Maintainer
            </button>
            <button
              class="btn btn-sm btn-outline-primary"
              @click="openMoveModal"
              v-if="canMoveToFacility"
            >
              <i class="fe fe-home mr-1"></i> Move to Facility
            </button>
            <button
              class="btn btn-sm btn-outline-dark"
              data-toggle="modal"
              data-target="#slideRightModalAll"
              @click="getActivities"
            >
              <i class="fe fe-activity mr-1"></i> Activities
            </button>
            <button
              class="btn btn-sm btn-warning"
              @click="blockUnblock"
              v-if="employeee && employeee.user && employeee.user.blocked_at == null"
            >
              <i class="fe fe-slash mr-1"></i> Block
            </button>
            <button
              class="btn btn-sm btn-success"
              @click="blockUnblock"
              v-if="employeee && employeee.user && employeee.user.blocked_at != null"
            >
              <i class="fe fe-check-circle mr-1"></i> Unblock
            </button>
          </div>
        </div>

        <!-- ── Sub-components ─────────────────────────────────── -->
        <div v-show="show" class="mb-3"><ChangePasswordEmployee /></div>
        <div v-show="showupdatedep" class="mb-3"><ChangeDept /></div>
        <div v-show="showedituser" class="mb-3"><EditUSerAdmin /></div>

        <div class="row">
          <!-- ── Enrollees Table ────────────────────────────── -->
          <div class="col-lg-8 col-12">
            <div class="card shadow table-card mb-4">
              <div class="d-flex align-items-center justify-content-between px-4 pt-4 pb-3">
                <div>
                  <h6 class="mb-0 font-weight-bold text-dark">
                    <i class="fe fe-users text-primary mr-2"></i>
                    {{ clients && clients.meta ? clients.meta.total : 0 }} Enrollees
                  </h6>
                  <small class="text-muted">Managed by this employee</small>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-head">
                    <tr>
                      <th class="table-th px-4">Name</th>
                      <th class="table-th">Phone Number</th>
                      <th class="table-th">Sector</th>
                      <th class="table-th">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="client in clients.data" :key="client.id" class="table-row">
                      <td class="px-4 py-3">
                        <p class="mb-0 font-weight-bold" style="font-size: .88rem;">
                          {{ client.firstname }} {{ client.middlename }} {{ client.lastname }}
                        </p>
                      </td>
                      <td class="py-3" style="font-size: .88rem;">{{ client.phone_number }}</td>
                      <td class="py-3">
                        <span class="rel-chip">{{ client.sector }}</span>
                      </td>
                      <td class="py-3">
                        <router-link :to="{ path: '/client/' + client.id }">
                          <button type="button" class="btn btn-sm btn-outline-primary">
                            <i class="fe fe-eye mr-1"></i> View
                          </button>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="px-4 py-3 d-flex" style="gap: 8px;">
                <button class="btn btn-sm btn-outline-secondary" @click="gotoPrevious">
                  <i class="fe fe-chevron-left mr-1"></i> Previous
                </button>
                <button class="btn btn-sm btn-outline-secondary" @click="gotoNext">
                  Next <i class="fe fe-chevron-right ml-1"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- ── Employee Details Sidebar ───────────────────── -->
          <div class="col-lg-4 col-md-12">
            <div class="card shadow table-card mb-4" v-if="employeee && employeee.user">
              <div class="form-card-header">
                <div class="section-number"><i class="fe fe-user" style="font-size: 12px;"></i></div>
                <h6 class="mb-0 font-weight-bold text-white">Employee Details</h6>
              </div>
              <ul class="list-unstyled mb-0">
                <li class="info-row">
                  <i class="fe fe-user info-icon"></i>
                  <div>
                    <p class="info-label">Full Name</p>
                    <p class="info-value">
                      {{ employeee.user.firstname }} {{ employeee.user.lastname }}
                      <span v-if="employeee.user.user_role == 1" class="status-badge status-badge--vetted ml-1" style="font-size:.7rem;">admin</span>
                    </p>
                  </div>
                </li>
                <li class="info-row">
                  <i class="fe fe-briefcase info-icon"></i>
                  <div>
                    <p class="info-label">Department / Job Title</p>
                    <p class="info-value">{{ employeee.user.job_title || '—' }}</p>
                  </div>
                </li>
                <li class="info-row">
                  <i class="fe fe-mail info-icon"></i>
                  <div>
                    <p class="info-label">Email</p>
                    <p class="info-value">{{ employeee.user.email }}</p>
                  </div>
                </li>
                <li class="info-row">
                  <i class="fe fe-phone info-icon"></i>
                  <div>
                    <p class="info-label">Phone Number</p>
                    <p class="info-value">{{ employeee.user.phone_number }}</p>
                  </div>
                </li>
                <li class="info-row">
                  <i class="fe fe-tag info-icon"></i>
                  <div>
                    <p class="info-label">User Type</p>
                    <p class="info-value">{{ employeee.user.type === 'provider_employee' ? 'Facility staff' : employeee.user.type === 'employee' ? 'Agency staff' : employeee.user.type }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- ── Sensitive changes made by this staff member (audit log) ── -->
        <SensitiveChanges :causer-id="$route.params.id" title="Sensitive changes made by this staff member" />
      </div>

      <!-- ── Move to Facility Modal ─────────────────────────── -->
      <div class="move-modal-overlay" v-if="moveModal.open" @click.self="moveModal.open = false">
        <div class="card shadow move-modal">
          <div class="form-card-header d-flex align-items-center justify-content-between">
            <h6 class="mb-0 font-weight-bold text-white">
              <i class="fe fe-home mr-1"></i> Move {{ employeee.user.firstname }} {{ employeee.user.lastname }} to a facility
            </h6>
            <button type="button" class="close text-white" aria-label="Close" @click="moveModal.open = false">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="card-body">
            <p class="text-muted" style="font-size: .85rem;">
              They stop being agency staff and become staff of the facility you choose. Their records and activity are kept.
              They are signed out and must sign in again.
            </p>

            <div class="form-group">
              <label class="small font-weight-bold text-secondary">Facility <span class="text-danger">*</span></label>
              <div v-if="moveModal.loadingProviders" class="text-muted small py-2">Loading facilities…</div>
              <v-select v-else v-model="moveModal.facility" :options="moveModal.providers" label="agency_name"
                placeholder="Search facility…" />
            </div>

            <div class="form-group">
              <label class="small font-weight-bold text-secondary">Job title at the facility <span class="text-danger">*</span></label>
              <select class="form-control" v-model="moveModal.job_title">
                <option v-for="t in facilityJobTitles" :key="t.value" :value="t.value">{{ t.label }}</option>
              </select>
            </div>

            <div class="form-group form-check">
              <input type="checkbox" class="form-check-input" id="moveFacilityAdmin" v-model="moveModal.facility_admin" />
              <label class="form-check-label small" for="moveFacilityAdmin">Make them an admin of the facility</label>
            </div>

            <div class="d-flex justify-content-end" style="gap: 8px;">
              <button type="button" class="btn btn-sm btn-outline-secondary" @click="moveModal.open = false">Cancel</button>
              <button type="button" class="btn btn-sm btn-submit" :disabled="!moveModal.facility || moveModal.submitting" @click="confirmMove">
                <i class="fe fe-check mr-1"></i> {{ moveModal.submitting ? 'Moving…' : 'Move to Facility' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- ── Activities Modal ───────────────────────────────── -->
      <div
        class="modal fade modal-slide-right"
        id="slideRightModalAll"
        tabindex="-1"
        role="dialog"
        aria-labelledby="slideRightModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content" id="printDiv" ref="printNow">
            <div class="modal-header" style="background: linear-gradient(135deg, #1e3a5f, #2563eb);">
              <div class="d-flex align-items-center">
                <div class="header-icon-wrap mr-3" style="width:36px;height:36px;">
                  <i class="fe fe-activity" style="font-size:16px;color:#fff;"></i>
                </div>
                <span class="h6 mb-0 font-weight-bold text-white" id="slideRightModalLabel">User Activities</span>
              </div>
              <button type="button" class="close text-white ml-auto" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body p-0">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-head">
                    <tr>
                      <th class="table-th px-4">Date</th>
                      <th class="table-th">Subject</th>
                      <th class="table-th">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="activity in activities.data" :key="activity.id" class="table-row">
                      <td class="px-4 py-3">
                        <p class="mb-1 small text-muted">{{ activity.created_at }}</p>
                        <span class="status-badge status-badge--approved" style="font-size:.7rem;">{{ activity.description }}</span>
                      </td>
                      <td class="py-3" style="font-size:.88rem;">{{ activity.subject_type }}</td>
                      <td class="py-3" style="font-size:.78rem;color:#64748b;">
                        {{ JSON.stringify(activity.properties) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-outline-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </div>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import SensitiveChanges from "@/views/reports/components/SensitiveChanges.vue";
import ChangePasswordEmployee from "@/views/auth/ChangePasswordEmployee.vue";
import EditUSerAdmin from "@/views/auth/EditUSerAdmin.vue";
import ChangeDept from "@/views/employees/ChangeDept.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: { SensitiveChanges,
    Navbar,
    Loading,
    ChangePasswordEmployee,
    ChangeDept,
    EditUSerAdmin,
  },
  data() {
    return {
      user: null,
      employeee: "",
      show: false,
      showupdatedep: false,
      showedituser: false,
      agencies: "",
      edit: false,
      isLoading: false,
      fullPage: true,
      current_page: "",
      unblock: null,
      clients: "",
      agency_id: "",
      activities: {data:[]},
      moveModal: {
        open: false,
        loadingProviders: false,
        submitting: false,
        providers: [],
        facility: null,
        job_title: "Desk",
        facility_admin: false,
      },
      // The facility's Add Employee page uses the same titles.
      facilityJobTitles: [
        { value: "Desk", label: "Desk Officer" },
        { value: "Doctor", label: "Doctor" },
        { value: "Pharmacist", label: "Pharmacist" },
        { value: "Nurse", label: "Nurse" },
        { value: "Laboratorist", label: "Laboratorist" },
        { value: "Accountant", label: "Accountant" },
        { value: "Extension Worker", label: "Community Health Extension Worker (CHEW)" },
      ],
    };
  },
  computed: {
    // Agency admins (the agency account or admin staff) move agency staff to one of the agency's facilities.
    canMoveToFacility() {
      const u = this.user;
      const isAgencyAdmin = !!u && (u.type === "shis" || (u.type === "employee" && Number(u.user_role) === 1));
      const target = this.employeee && this.employeee.user;
      return isAgencyAdmin && !!target && target.type === "employee" && Number(target.id) !== Number(u.id);
    },
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    openMoveModal() {
      const agency = JSON.parse(localStorage.getItem("agency") || "null");
      this.moveModal = { ...this.moveModal, open: true, facility: null, job_title: "Desk", facility_admin: false };
      if (this.moveModal.providers.length || !agency) return;
      this.moveModal.loadingProviders = true;
      this.axios
        .get(`/api/v1/auth/providerAgency/${agency.id}`)
        .then((response) => {
          this.moveModal.providers = (response.data.data || []).filter((p) => p.status !== false && p.status !== 0);
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Could not load the facilities.", { position: "top-center", duration: 4000 });
        })
        .finally(() => { this.moveModal.loadingProviders = false; });
    },
    confirmMove() {
      const facility = this.moveModal.facility;
      const name = `${this.employeee.user.firstname} ${this.employeee.user.lastname}`;
      if (!facility || !confirm(`Move ${name} to ${facility.agency_name}? They will no longer be agency staff.`)) return;
      this.moveModal.submitting = true;
      this.axios
        .post(`/api/v1/auth/agency-staff/${this.$route.params.id}/move-to-facility`, {
          facility_id: facility.id,
          job_title: this.moveModal.job_title,
          facility_admin: this.moveModal.facility_admin,
        })
        .then((response) => {
          this.moveModal.open = false;
          this.$toasted.success(response.data.message || "Moved to the facility.", { position: "top-center", duration: 4000 });
          this.getEmployee();
        })
        .catch((error) => {
          const message = error.response && error.response.data && error.response.data.message;
          this.$toasted.error(message || "Could not move the staff member.", { position: "top-center", duration: 6000 });
        })
        .finally(() => { this.moveModal.submitting = false; });
    },
    blockUnblock() {
      if (this.employeee.user.blocked_at == null) {
        this.axios
          .patch(`/api/v1/auth/block-user/${this.$route.params.id}`, {
            blocked_at: "2021-01-01",
          })
          .then((response) => {
            console.log(response);
            this.$toasted.info("Blocked Successfully!", {
              position: "top-center",
              duration: 3000,
            });
            this.getEmployee();
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.axios
          .patch(`/api/v1/auth/block-user/${this.$route.params.id}`, {
            blocked_at: null,
          })
          .then((response) => {
            console.log(response);
            console.log("ublock");
            this.$toasted.info("Unblocked Successfully!", {
              position: "top-center",
              duration: 3000,
            });
            this.getEmployee();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    updateRole() {
      if (this.employeee.user.user_role == 1) {
        this.axios
          .post(`/api/v1/auth/update-role/${this.$route.params.id}`, {
            role: 0,
          })
          .then((response) => {
            console.log(response);
            this.$toasted.info("Changed Successfully!", {
              position: "top-center",
              duration: 3000,
            });
            this.getEmployee();
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.axios
          .post(`/api/v1/auth/update-role/${this.$route.params.id}`, {
            role: 1,
          })
          .then((response) => {
            console.log(response);
            this.$toasted.info("Changed Successfully!", {
              position: "top-center",
              duration: 3000,
            });
            this.getEmployee();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    gotoNext() {
      if (this.clients.meta.current_page != this.clients.meta.last_page) {
        this.current_page++;
        this.getClients();
      } else {
        this.$toasted.info("You have reached the Last Page", {
          position: "top-center",
          duration: 3000,
        });
      }
    },
    gotoPrevious() {
      if (this.clients.meta.current_page != 1) {
        this.current_page--;
        this.getClients();
      } else {
        this.$toasted.info("You have reached the First Page", {
          position: "top-center",
          duration: 3000,
        });
      }
    },
    getEmployee() {
      this.axios
        .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
        .then((response) => {
          this.employeee = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    EmployeeClients() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios
        .get(`/api/v1/auth/employee_client/${this.$route.params.id}`, {
          params: {
            page: this.current_page,
          },
        })
        .then((response) => {
          this.clients = response.data;
          this.isLoading = false;
          console.log(response);
        })
        .catch((error) => {
          this.isLoading = false;
          console.error(error);
        });
    },
    getActivities() {
      this.axios
        .get(`/api/v1/auth/user-activities/${this.$route.params.id}`)
        .then((response) => {
          this.activities = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.getEmployee();
    this.EmployeeClients();
    this.getActivities();
  },
};
</script>

<style scoped>
.move-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1050;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.move-modal {
  width: 100%;
  max-width: 480px;
  border-radius: 12px;
  overflow: visible;
}
</style>
